import { Checkbox } from "antd";
import _ from "lodash";
import React, { useState } from "react";
import { toast } from "react-toastify";
import styled from "styled-components";

import { Button } from "@components/Button";
import { COLOR_GREEN, COLOR_WHITE } from "@static/COLORS";
import { getUserExtraCustomers } from "@utils/getUserExtraCustomers";
import { fetchAPI } from "@utils/https/fetchAPI";

const FormContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  position: relative;
  flex-direction: column;
  gap: 2px;
`;

const Line = styled.div`
  width: 100%;
  height: 1px;
  margin-bottom: 8px;
  background-color: rgba(0, 0, 0, 0.1);
`;

// const InnerContainer = styled.div`
//   display: flex;
//   flex-direction: column;
//   justify-content: space-between;
//   flex-grow: 1;
//   overflow: hidden;
// `;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  height: 40px;
`;

const SectionSelectLocation = styled.div`
  height: calc(100% - 58px);
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
// locationList
export const FormManageCustomers = ({
  selectedData,
  locationList,
  setIsModalVisible,
  setSelectedData,
  setDataList,
  customerOptions,
}) => {
  const allCustomers = getUserExtraCustomers();

  console.log("selectedData :>> ", selectedData);
  const user_id = _.get(selectedData, ["id"]);
  const category_customer_id = _.get(selectedData, ["category_customer_id"]);
  const userExtraCustomers = _.chain(selectedData)
    .get(["userExtraCustomers"])
    .map((item) => {
      return _.get(item, ["category_customer_id"]);
    })
    // .concat(category_customer_id)
    .value();
  console.log("userExtraCustomers :>> ", userExtraCustomers);

  // const locationList = _.map(new Array(100), (item, index) => {
  //   console.log("index :>> ", index);
  //   return {
  //     id: index + 1,
  //     name: `mock ${index + 1}`,
  //     category_customer_id: 1,
  //   };
  // });

  const [selectedExtraCustomers, setSelectedExtraCustomers] =
    useState(userExtraCustomers);

  const onHandleUpdateManageCustomer = async () => {
    const updateExtraCustomer = _.chain(selectedExtraCustomers)
      .map((item) => {
        return {
          user_id,
          category_customer_id: item,
        };
      })
      .value();

    console.log("updateExtraCustomer :>> ", updateExtraCustomer);
    const resp = await fetchAPI({
      method: "post",
      path: "/api/v1/user-update-extra-customers",
      isAuth: true,
      data: { user_id, extra_customers: updateExtraCustomer },
    });
    if (_.get(resp, ["status"])) {
      const results = _.chain(resp).get(["result"]).value();
      console.log("results :>> ", results);
      const extraCustomers = _.map(results, (resultItem) => {
        const updateUserId = _.chain(resultItem)
          .get(["user_id"])
          .toInteger()
          .value();

        const categoryCustomerId = _.chain(resultItem)
          .get(["category_customer_id"])
          .toInteger()
          .value();
        return {
          ...resultItem,
          user_id: updateUserId,
          category_customer_id: categoryCustomerId,
        };
      });

      // console.log("extraCustomers :>> ", extraCustomers);
      const updateData = {
        ...selectedData,
        userExtraCustomers: extraCustomers,
      };
      console.log("updateData :>> ", updateData);
      toast.success("Update User Success.");
      setIsModalVisible((prev) => ({ ...prev, isOpen: false }));
      setSelectedData(null);
      setDataList((prev) => {
        const updateDataList = _.map(prev, (item) => {
          return _.get(item, ["id"]) ===
            _.chain(updateData).get(["id"]).toInteger().value()
            ? updateData
            : item;
        });

        console.log("updateDataList :>> ", updateDataList);
        return updateDataList;
      });
    }
    // console.log("updateManageLocation :>> ", updateManageLocation);
  };

  const onChangeCheckbox = ({ customerId }) => {
    console.log("customerId :>> ", customerId);
    const updateSelectedLocation = _.includes(
      selectedExtraCustomers,
      customerId
    )
      ? _.filter(selectedExtraCustomers, (item) => item !== customerId)
      : [...selectedExtraCustomers, customerId];
    setSelectedExtraCustomers(updateSelectedLocation);
  };

  return (
    <FormContainer>
      <Line />
      <SectionSelectLocation>
        {_.map(customerOptions, (item, index) => {
          const customerId = _.get(item, ["value"]);
          const customerName = _.get(item, ["label"]);

          const concatCurrentCustomerList = _.concat(
            selectedExtraCustomers,
            category_customer_id
          );
          return (
            <Checkbox
              key={index}
              disabled={customerId === category_customer_id}
              checked={_.includes(concatCurrentCustomerList, customerId)}
              onChange={() => onChangeCheckbox({ customerId })}
            >
              {customerName}
            </Checkbox>
          );
        })}
      </SectionSelectLocation>

      <ButtonContainer>
        <Button
          type="submit"
          color={COLOR_GREEN}
          fontColor={COLOR_WHITE}
          fontSize="16px"
          padding="5px 20px"
          onClick={() => onHandleUpdateManageCustomer()}
        >
          Save
        </Button>
      </ButtonContainer>
    </FormContainer>
  );
};
